import React, { useState, useEffect } from 'react';
import axios from '../common/axios';
import Swal from 'sweetalert2';
import Layout from '../layout/Layout';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';


export const UpdateContact = ({  }) => {
  const {t} = useTranslation();

    const [data, setData] = useState({});
    const navigate = useNavigate(); // 변경된 부분


    useEffect(() => {
        const fetchData = async () => {
          try {
            const res = await axios.get('/getvendor'); 
            if(res.data.success){
              setData( {record_no:res.data.data.record_no,contact:res.data.data.contact});
            }
           
          } catch (error) {
            console.error('데이터 가져오기 중 오류 발생:', error);
          }
        };
        fetchData();
      }, []);

   

      const tableColumns = [
        {
          label: '영업', // 원래 값 유지
          key: 'sales',
          inputs: [
            { name: 'name', placeholder: '', maxWidth: 100 },
            { name: 'phone', placeholder: '', maxWidth: 200 },
            { name: 'email', placeholder: '', maxWidth: 250 },
          ],
        },
        {
          label: '납기',
          key: 'delivery',
          inputs: [
            { name: 'name', placeholder: '', maxWidth: 100 },
            { name: 'phone', placeholder: '', maxWidth: 200 },
            { name: 'email', placeholder: '', maxWidth: 250 },
          ],
        },
        {
          label: '품질',
          key: 'quality',
          inputs: [
            { name: 'name', placeholder: '', maxWidth: 100 },
            { name: 'phone', placeholder: '', maxWidth: 200 },
            { name: 'email', placeholder: '', maxWidth: 250 },
          ],
        },
        {
          label: '세금계산서',
          key: 'invoice',
          inputs: [
            { name: 'name', placeholder: '', maxWidth: 100 },
            { name: 'phone', placeholder: '', maxWidth: 200 },
            { name: 'email', placeholder: '', maxWidth: 250 },
          ],
        },
        {
          label: '입찰',
          key: 'bid',
          inputs: [
            { name: 'name', placeholder: '', maxWidth: 100 },
            { name: 'phone', placeholder: '', maxWidth: 200 },
            { name: 'email', placeholder: '', maxWidth: 250 },
          ],
        },
      ];

      useEffect(() => {
        if (data && data.contact) {
            const formattedData = data.contact.reduce((acc, curr) => {
                acc[curr.JobPosition] = {
                    name: curr.uriCntctLstNmTB + curr.uirCntctFstNmTB,
                    phone: curr.uuu_user_workphone,
                    email: curr.BidderPersonMail,
                    LineAutoSeq: curr.LineAutoSeq,
                };
                return acc;
            }, {});
            setTableData(formattedData);
        }
    }, [data]);

      const [tableData, setTableData] = useState({});

      const tabalarray = tableData && Object.entries(tableData).map(([type, data]) => ({
        type,
        ...data
      }));
    
      const dataSend = 
        {
            record_no:data.record_no, _bp_lineitems:
          tabalarray.map((v)=>({
                LineAutoSeq:v.LineAutoSeq, uuu_tab_id:"List of Contacts", 
                uirCntctFstNmTB:v.name.slice(1,10),uriCntctLstNmTB:v.name.slice(0,1),JobPosition:v.type, 
                BidderPersonMail:v.email, uuu_user_workphone:v.phone
            }))
        }

      

        // input 값이 변경될 때 호출되는 핸들러 함수
        const handleInputChange = (e, columnName, inputName) => {
          const { value } = e.target;
          setTableData((prevTableData) => ({
              ...prevTableData,
              [columnName]: { ...prevTableData[columnName], [inputName]: value }
          }));
      };
  
      const handleSubmit = () => {
          Swal.fire({
              title: t('updateInfo.submitConfirmationTitle'),
              text: t('updateInfo.submitConfirmationText'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: t('updateInfo.submitConfirmationYes'),
              cancelButtonText: t('updateInfo.submitConfirmationNo')
          }).then((result) => {
              if (result.isConfirmed) {
                  sendInfo(dataSend);
              }
          });
      };
  
      const sendInfo = (dataSend) => {    
          console.log(dataSend);
          axios.post('/updatevendor2', { dataSend })
          .then(response => {
              if (response.data.success) {
                  Swal.fire({
                      title: t('updateInfo.submitSuccessTitle'),
                      text: t('updateInfo.submitSuccessText'),
                      icon: 'success',
                      confirmButtonText: 'OK'
                  }).then(() => {
                      navigate('/home');
                  });
              } else {
                  Swal.fire({
                      title: t('updateInfo.submitErrorTitle'),
                      text: response.data.data,
                      icon: 'error',
                      confirmButtonText: 'OK'
                  });
              }
          })
          .catch(err => {
              const errorMessage = err.message || t('updateInfo.submitErrorText');
              Swal.fire({
                  title: t('updateInfo.submitErrorTitle'),
                  text: errorMessage,
                  icon: 'error',
                  confirmButtonText: 'OK'
              });
          });
      };
  
      return (
          <div className='app-content flex-column-fluid'>
              <div className='app-container container-xxl'>
                  <div className="card mb-5 mb-xl-8">
                      <div className="card-header border-0 pt-5">
                          <h3 className="card-title align-items-start flex-column">
                              <span className="card-label fw-bold fs-3 mb-1">{t('nav.contactInfoUpdate')}</span>
                              <span className="text-muted mt-1 fw-semibold fs-7">{t('updateInfo.updateSubtitle')} <br />
                                  <span className='badge badge-light-danger fw-semibold me-1'>{t('updateInfo.bidWarning')}</span>
                              </span>
                          </h3>
                          <div className="card-toolbar">
                              <button className='btn btn-sm fw-bold btn-primary' type='button' onClick={handleSubmit}>
                                  {t('updateInfo.submitButton')} &nbsp;&nbsp;
                                  <i className="ki-duotone ki-send fs-3">
                                      <span className="path1"></span>
                                      <span className="path2"></span>
                                  </i>
                              </button>
                          </div>
                      </div>
                      <div className="card-body py-3">
                          <div className="table-responsive design">
                              <table className="table align-middle gs-0 gy-4">
                                  <thead>
                                      <tr className="fw-bold text-muted bg-light">
                                          <th className="min-w-50px rounded-start">{t('updateInfo.tableHeaders.item')}</th>
                                          <th className="min-w-80px">{t('updateInfo.tableHeaders.name')}</th>
                                          <th className="min-w-100px">{t('updateInfo.tableHeaders.phone')}</th>
                                          <th className="min-w-150px rounded-end">{t('updateInfo.tableHeaders.email')}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                  {tableColumns.map((column, columnIndex) => (
                                    <tr key={columnIndex}>
                                      <td className="text-dark fw-bold text-hover-primary fs-6">{t(`updateInfo.tableHeaders.${column.key}`)}</td>
                                      {column.inputs.map((input, inputIndex) => (
                                        <td key={inputIndex} className="text-dark fw-bold text-hover-primary fs-6">
                                          <input
                                            type="text"
                                            className="form-control form-control-solid"
                                            placeholder={input.placeholder}
                                            name={input.name}
                                            style={{ maxWidth: input.maxWidth }}
                                            value={tableData[column.label]?.[input.name] || ''}
                                            onChange={(e) => handleInputChange(e, column.label, input.name)}
                                          />
                                        </td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                          </div> 
                      </div>
                  </div>
              </div>
          </div>
      );
  };

